// actions/pubsub/list.js

import { attachAuth } from '../../utils/authService';

export function listHasErrored(bool) {
  return {
    type: 'LIST_HAS_ERRORED',
    hasErrored: bool
  };
}

export function listIsLoading(bool) {
  return {
    type: 'LIST_IS_LOADING',
    isLoading: bool
  };
}

export function listFetchDataSuccess(items) {
  return {
    type: 'LIST_FETCH_DATA_SUCCESS',
    items
  };
}

export function listFetchData(host) {
  return (dispatch) => {
    dispatch(listIsLoading(true));
    dispatch(listHasErrored(false));
    fetch(host + 'admin/list', {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
        
      dispatch(listIsLoading(false));
      promise.json()
        .then(result => {
          dispatch(listFetchDataSuccess(result))
        })
        .catch(() => dispatch(listHasErrored(true)));
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(listHasErrored(true));
      dispatch(listIsLoading(false));
    });
  };
}